import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moDifferent from './store';
import PDF from '../../component/pdf';
import Title from '../../component/title';
import HeadPdf from '../../component/head-pdf';
import FootPdf from '../../component/foot-pdf';
import moIndex from '../../store/index';
import CityDiff from './index';

interface IProps {
  list: any[],
  page: number,
}
interface IState {}

const ExplainPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry, cityDiffYear } = moIndex;
  const { list, page } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <PDF>
      <section className="city-different-pdf_3030">
        <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
        <section className="different-content_3030">
          <section className="title-1001">
            <Title title="城市薪酬差异系数" bigTitle="人力指标" tag={`${cityDiffYear}年`} />
          </section>

          <CityDiff list={list} page={page} />
        </section>
        <FootPdf />
      </section>
    </PDF>
  );
};

export default observer(ExplainPDF);
